"use client";

// Icon Component
const Icon = ({
    path,
    size = 24,
    className = "",
    fill = "none",
    strokeWidth = 2,
}: {
    path: React.ReactNode;
    size?: number;
    className?: string;
    fill?: string;
    strokeWidth?: number;
}) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill={fill}
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
        className={className}
    >
        {path}
    </svg>
);

// Star Icon
const StarIcon = <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />;

const Lucide = (props: { name: string; size?: number; className?: string; fill?: string; strokeWidth?: number }) => {
    const { name, ...rest } = props;
    if (name === "Star") {
        return <Icon path={StarIcon} {...rest} />;
    }
    return null;
};

// RatingDisplay Component
export const RatingDisplay = ({ rating }: { rating: number }) => {
    // Always show rating, even if 0
    const displayRating = rating || 0;
    const hasRating = rating > 0;

    return (
        <div className={`flex items-center gap-1 ${hasRating ? 'text-amber-500' : 'text-aera-gray'}`}>
            <Lucide name="Star" size={10} fill={hasRating ? "currentColor" : "none"} />
            <span className="text-[10px] font-medium text-aera-charcoal">{displayRating.toFixed(1)}</span>
        </div>
    );
};

export default RatingDisplay;
